export default __webpack_public_path__ + "static/media/PSMD1.e2ddb698.png";